"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const ContentHeader = (props) => {
    const { title, subTitle, descriptionElement, content, navLeft, navRight, children } = props;
    return (react_1.default.createElement("div", { className: 'content-header' },
        react_1.default.createElement("div", { className: 'sub-nav-container' },
            navLeft && react_1.default.createElement("div", { className: 'sub-nav-left' }, navLeft),
            navRight && react_1.default.createElement("div", { className: 'sub-nav-right' }, navRight)),
        react_1.default.createElement("div", { className: 'data-container' },
            react_1.default.createElement("div", { className: 'left-data' },
                react_1.default.createElement("h2", null, title),
                subTitle && react_1.default.createElement("h4", null,
                    " - ",
                    subTitle),
                descriptionElement && react_1.default.createElement("div", { className: "head-description" }, descriptionElement),
                content && react_1.default.createElement("div", { className: 'description-content' },
                    " ",
                    content,
                    " ")),
            react_1.default.createElement("div", { className: 'right-data' }, children))));
};
exports.default = ContentHeader;
